import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import {
  getActivityQuestion,
  getActivityId,
  getActivityProQuote,
  getActivityProQuoteAuthor,
  getActivityDescription,
  getActivityDay,
  getActivityUserActivityId,
} from 'store/entities/activity/selectors'
import UserStoryForm from 'app/domains/common/UserStoryForm'
import { setStory } from 'store/entities/activity/actions'
import UniversalPopover from 'app/domains/common/UniversalPopover'
import NoteQuotes from 'app/components/NoteQuotes'
import { getIdentityActiveProTrackName } from 'store/entities/identity/selectors'

const mapStateToPropsNote = createStructuredSelector({
  proQuote: getActivityProQuote,
  proQuoteAuthor: getActivityProQuoteAuthor,
  description: getActivityDescription,
  activityDay: getActivityDay,
  protrackName: getIdentityActiveProTrackName,
})

const Note = connect(mapStateToPropsNote)(NoteQuotes)

const Title = () => {
  return (
    <UniversalPopover body={<Note />}>
      <span style={{ color: '#2ed8a7', cursor: 'pointer' }}>today's</span>
    </UniversalPopover>
  )
}

const mapStateToProps = createStructuredSelector({
  question: getActivityQuestion,
  activityId: getActivityId,
  userActivityId: getActivityUserActivityId,
  title: Title,
})

const mapDispatchToProps = {
  setStory,
}

export default connect(mapStateToProps, mapDispatchToProps)(UserStoryForm)
